var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16592 14H12.5252C12.8624 10.7859 13.8598 7.68767 15.442 4.89594C11.6685 6.44653 8.85969 9.86467 8.16592 14ZM20.0001 5.17615C18.1409 7.78573 16.9554 10.8177 16.5517 14H23.4517C23.0475 10.8181 21.8604 7.78606 20.0001 5.17615ZM23.4517 18C23.0475 21.1819 21.8604 24.2139 20.0001 26.8239C18.1409 24.2143 16.9554 21.1823 16.5517 18H23.4517ZM12.5252 18H8.16592C8.85969 22.1353 11.6685 25.5535 15.442 27.1041C13.8598 24.3123 12.8624 21.2141 12.5252 18ZM22 31.8762C29.8926 30.892 36 24.1592 36 16C36 7.16344 28.8366 0 20 0C11.1634 0 4 7.16344 4 16C4 24.1592 10.1074 30.892 18 31.8762V32.3414C16.2952 32.944 14.944 34.2952 14.3414 36H2C0.89543 36 0 36.8954 0 38C0 39.1046 0.89543 40 2 40H14.3414C15.1651 42.3304 17.3876 44 20 44C22.6124 44 24.8349 42.3304 25.6586 40H38C39.1046 40 40 39.1046 40 38C40 36.8954 39.1046 36 38 36H25.6586C25.056 34.2952 23.7048 32.944 22 32.3414V31.8762ZM24.5591 27.1036C26.1419 24.3122 27.1406 21.2142 27.4783 18H31.8341C31.1404 22.1349 28.332 25.5528 24.5591 27.1036ZM31.8341 14H27.4783C27.1406 10.7858 26.1419 7.68776 24.5591 4.89638C28.332 6.44719 31.1404 9.86507 31.8341 14ZM20 36C18.8954 36 18 36.8954 18 38C18 39.1046 18.8954 40 20 40C21.1046 40 22 39.1046 22 38C22 36.8954 21.1046 36 20 36Z",
    fill: "url(#paint0_linear_25519_1872)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25519_1872",
    x1: 0,
    y1: 0,
    x2: 23.2246,
    y2: 42.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.b04a3d0b8ac7e28a26ec7b766805cd42.svg";
export { ForwardRef as ReactComponent };